import React from 'react';
import PropTypes from 'prop-types';
import {
    FormattedDate,
    CurrencyIcon,
} from '@ya.praktikum/react-developer-burger-ui-components';
import styles from './order-history-card.module.css';
import {
    TIngredientType,
    TwsOrder,
    OrderStatus,
    OrderStatusColor,
} from '../../utils/types';
import IngredientElement from '../ingredient-element/ingredient-element';

type TOrderHistoryProps = {
    wsOrder: TwsOrder;
    items: { [id: string]: TIngredientType };
    status?: boolean;
    onClick?: () => void;
};

// type Desc = keyof typeof OrderStatus;

function OrderHistoryCard({
    wsOrder,
    items,
    status,
    onClick,
}: TOrderHistoryProps): JSX.Element {
    // const statusDesc = Object.keys(OrderStatus).indexOf(wsOrder.status);

    // const num = OrderStatus[Desc];

    return (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events
        <div
            className={`${styles.feed__item_block} text text_type_main-default`}
            // eslint-disable-next-line no-underscore-dangle
            key={wsOrder._id}
            onClick={onClick}
            role="button"
            tabIndex={0}
        >
            <div className={styles.feed__item_head}>
                <span className="pr-2">#{wsOrder.number}</span>
                <FormattedDate
                    date={new Date(wsOrder.createdAt)}
                    className="pl-2 pr-2 text text_type_main-default text_color_inactive"
                />
            </div>
            <div>{wsOrder.name}</div>
            {status && (
                <div
                    style={{ color: OrderStatusColor[wsOrder.status] }}
                    className="text text_type_main-small"
                >
                    {OrderStatus[wsOrder.status]}
                </div>
            )}
            <div className={styles.feed_boxcover}>
                <div className={styles.feed_box}>
                    {wsOrder.ingredients
                        .slice()
                        .reverse()
                        .slice(0, 6)
                        .map((id: string, index) => {
                            const ing: TIngredientType = items[id];
                            return (
                                ing && (
                                    <IngredientElement
                                        item={ing}
                                        number={
                                            index === 0 &&
                                            wsOrder.ingredients.length > 6
                                                ? wsOrder.ingredients.length - 6
                                                : 0
                                        }
                                    />
                                )
                            );
                        })}
                </div>

                <div
                    className="pl-2 pr-8"
                    style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                    }}
                >
                    <div className="text text_type_digits-default pl-4 pr-4">
                        {wsOrder.ingredients.reduce(
                            (p, c) => p + (items[c] ? items[c].price : 0),
                            0
                        )}
                    </div>
                    <CurrencyIcon type="primary" />
                </div>
            </div>
        </div>
    );
}
OrderHistoryCard.propTypes = {
    status: PropTypes.bool,
    onClick: PropTypes.func,
};
OrderHistoryCard.defaultProps = {
    status: false,
    onClick: () => {},
};
export default OrderHistoryCard;
